import axios from "axios";
import { API } from "../App";

// index.html starts the first API request for /article/:slug and /category/:c before the bundle downloads
// (window.__pwmEarly = { path, promise, data? }). Consume it once when the path matches; otherwise use axios.
const claim = (apiPath) => {
  const early = typeof window !== "undefined" ? window.__pwmEarly : null;
  if (!early || early.used || early.path !== apiPath) return null;
  early.used = true;
  return early;
};

// Synchronous: parsed JSON when the early response already arrived (lets the first React render paint the hero).
export const peekEarlyData = (apiPath) => {
  const early = typeof window !== "undefined" ? window.__pwmEarly : null;
  if (!early || early.used || early.path !== apiPath || early.data === undefined) return null;
  early.used = true;
  return early.data;
};

export const takeEarlyData = (apiPath) => {
  const early = claim(apiPath);
  if (!early) return null;
  if (early.data !== undefined) return Promise.resolve(early.data);
  return early.promise.then((r) => {
    if (!r.ok) {
      const err = new Error(`Request failed with status code ${r.status}`);
      err.response = { status: r.status };
      throw err;
    }
    return r.json();
  });
};

export const getJson = (apiPath) => takeEarlyData(apiPath) || axios.get(`${API}${apiPath}`).then((r) => r.data);
